import React, { useCallback } from 'react'
import { AnimatePresence } from 'framer-motion'
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil'
import {
  selectedClients as selectedClientsState,
  currentSection as currentSectionState,
  currentFix as currentFixState,
  lastSection as lastSectionState,
} from '../../store/uiStore'
import { siteSections as siteSectionsState } from '../../store/dataStore'
import { ShowNextButton } from '../../styles/headerStyles'
import { NextArrow } from '../../assets/svg/icons'

const NextButton = () => {

  const [currentSection, setCurrentSection] = useRecoilState(
    currentSectionState
  )
  const [currentFix, setCurrentFix] = useRecoilState(
    currentFixState
  )
  const [lastSection, setLastSection] = useRecoilState(
    lastSectionState
  )
  const setSelectedClients = useSetRecoilState(
    selectedClientsState
  )
  const menuLinks = useRecoilValue(siteSectionsState).slice(1)

  const handleNextClick = useCallback(() => {
    const currentIndex = Object.entries(menuLinks).findIndex(
      ([id, { link, slug }]) => slug === currentFix
    )
    if ( currentIndex >= 0 ) {
      const next = menuLinks[currentIndex + 1].slug
      if (next === 'clientes' || next === 'aliados') {
        setSelectedClients((last) => next === 'clientes' ? 0 : 1)
        setCurrentSection((last) => 'clientes')
      } else {
        setCurrentSection((last) => next)
      }
      setLastSection((last) => currentFix)
      setCurrentFix((last) => next)
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [lastSection])

  return (
    <AnimatePresence exitBeforeEnter>
      {currentSection !== 'contacto' && (
        <ShowNextButton
          onClick={() => handleNextClick()}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1, ease: 'easeOut' }}
          aria-label='Siguiente'>
          <div>
            <NextArrow />
          </div>
        </ShowNextButton>
      )}
    </AnimatePresence>
  )
}

export default NextButton
